import logosAndTerms from '../../ltl/logos-and-terms.json';

const logoByScac = new Map(logosAndTerms.data.map((entry) => [entry.key, entry.logo]));

export const getCarrierLogoSrc = (carrierScac: string | null | undefined): string | undefined =>
  carrierScac ? logoByScac.get(carrierScac) : undefined;
